export default {
    'settings.title': '頁面配置',
    'settings.themeColor': '主題色',
    'settings.content': '內容區域',
    'settings.search': '搜索',
    'settings.language': '語言',
    'settings.navbar': '導航欄',
    'settings.menuWidth': '菜單寬度 (px)',
    'settings.navbar.theme.toLight': '點擊切換為亮色模式',
    'settings.navbar.theme.toDark': '點擊切換為暗黑模式',
    'settings.navbar.screen.toFull': '點擊切換全屏模式',
    'settings.navbar.screen.toExit': '點擊退出全屏模式',
    'settings.navbar.alerts': '消息通知',
    'settings.menu': '菜單欄',
    'settings.topMenu': '頂部菜單欄',
    'settings.tabBar': '多頁簽',
    'settings.footer': '底部',
    'settings.otherSettings': '其他設置',
    'settings.colorWeak': '色弱模式',
    'settings.alertContent':
        '配置之後僅是臨時生效，要想真正作用於項目，點擊下方的 "復製配置" 按鈕，將配置替換到 settings.json 中即可。',
    'settings.copySettings': '復製配置',
    'settings.copySettings.message':
        '復製成功，請粘貼到 src/settings.json 文件中',
    'settings.close': '關閉',
    'settings.color.tooltip':
        '根據主題顏色生成的 10 個梯度色（將配置復製到項目中，主題色才能對亮色 / 暗黑模式同時生效）',
    'settings.menuFromServer': '菜單來源於後臺',
    'modPass': '修改密碼',
    'oldPass': '舊密碼',
    'newPass': '新密碼',
    'logOut': '退出登錄',
};
